export const SET_PLANS = 'setPlans'
export const RESET_PLANS = 'resetPlans'
